import { Component, OnInit, Input, HostBinding, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { NavegationStateService } from '../../providers/navegation-state.service';

@Component({
    selector: 'roblex-navegation',
    templateUrl: './navegation.component.html',
    styleUrls: [ './navegation.component.scss' ],
    host: {
        class: 'wrapper-navigation navigation-list'
    },
})
export class NavegationComponent implements OnInit, AfterViewInit {
    @Input() positionFixed = true;
    @HostBinding('class') position = 'position-relative';

    constructor(public navegationStateService: NavegationStateService,
                private cdRef: ChangeDetectorRef) {
        //
    }

    ngOnInit(): void {
        if ( this.positionFixed ) {
            this.position = 'position-fixed';
        }
        this.navegationStateService.home$.subscribe((res) => {
            // console.log(res);
        });
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

}
